export function sanitizeFileName(name: string): string {
  // Extract extension if present
  const parts = name.split(".");
  const ext = parts.length > 1 ? "." + parts.pop() : "";
  let base = parts.join(".");

  // Lowercase
  base = base.toLowerCase();

  // Replace spaces and unsafe characters with hyphen
  base = base.replace(/[^a-z0-9_-]/g, "-");

  // Collapse multiple hyphens
  base = base.replace(/-+/g, "-");

  // Trim leading/trailing hyphens
  base = base.replace(/^-+|-+$/g, "");

  // Enforce max length (reserve room for extension)
  const maxBaseLength = 200 - ext.length;
  if (base.length > maxBaseLength) {
    base = base.substring(0, maxBaseLength);
  }

  return base + ext;
}
